<template>
  <div class="bl-target-details-container">
    <div id="target-details" class="p-6 space-y-4">
      <div class="flex items-center gap-4">
        <BlTextSubtitle1 text="Details" />
        <BlInputButton
          v-if="!readonly"
          type="outlined"
          dense
          label="Edit"
          @clicked="onOpenEditDetails"
        />
      </div>
      <div class="space-y-5">
        <!-- target name -->
        <div class="grid grid-cols-4 gap-x-4">
          <BlTextBody2 class="mt-0.5" text="Title" />
          <BlTextBody1 :text="task.title" class="col-span-3 text-grey" />
        </div>
        <div class="grid grid-cols-4 gap-x-4">
          <BlTextBody2 class="mt-0.5" text="Code" />
          <BlTextBody1 :text="task.code" class="col-span-3 text-grey" />
        </div>
        <!-- target curriculum -->
        <div class="grid grid-cols-4 gap-x-4">
          <BlTextBody2 class="mt-0.5" text="Curriculum" />
          <div class="flex col-span-3 gap-2">
            <div
              class="flex-shrink-0 rounded-full w-5 h-5 mt-0.5"
              :style="{ backgroundColor: target.curriculum_color }"
            />
            <BlTextBody1 :text="target.curriculum_name" class="text-grey" />
          </div>
        </div>
        <!-- target type -->
        <div class="grid items-center grid-cols-4 gap-x-4">
          <BlTextBody2 text="Data collection method" />
          <BlTextBody1
            text="Skill-Based Treatment (SBT)"
            class="col-span-3 text-grey"
          />
        </div>
        <!-- target description -->
        <div class="grid grid-cols-4 gap-x-4">
          <BlTextBody2 class="mt-0.5" text="Graph color" />
          <div class="w-24 h-1 col-span-3" :style="{ backgroundColor: task.color }"></div>

        </div>
        <div class="grid grid-cols-4 gap-x-4">
          <BlTextBody2 class="mt-0.5" text="Description" />
          <BlTextBody1
            :text="task.description || '-'"
            class="col-span-3 text-base whitespace-pre-line text-grey"
          />
        </div>
      </div>
    </div>
    <EditTaskDetailsModal
      v-if="editDetailsOpened"
      :target="target"
      :task="task"
      @close-modal="editDetailsOpened = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PromptPreview from "@/components/repository/prompting/Preview.vue";
import SbtPromptingPreview from "@/components/repository/sbt/PromptingPreview.vue";
import EditPromptsModal from "./modal/EditPromptsModal.vue";
import EditProbingModal from "./modal/EditProbingModal.vue";
import EditActionRecommendationsModal from "./modal/EditActionRecommendationsModal.vue";

import BlTextSubtitle1 from "../../BlTextSubtitle1.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlBackdrop from "../../BlBackdrop.vue";
import BlIcon from "../../BlIcon.vue";
import StatusChip from "./StatusChip.vue";
import BlTextSubtitle2 from "../../BlTextSubtitle2.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody1 from "../../BlTextBody1.vue";
import EditTaskDetailsModal from "./modal/EditTaskDetailsModal.vue";

export default {
  name: "TaskPropertyDetails",
  components: {
    EditTaskDetailsModal,
    PromptPreview,
    EditPromptsModal,
    EditProbingModal,
    EditActionRecommendationsModal,
    SbtPromptingPreview,
    //
    BlTextSubtitle1,
    BlInputButton,
    BlTextBody2,
    BlTextBody1,
    BlBackdrop,
    BlIcon,
    StatusChip,
    BlTextSubtitle2,
    BlTextSubtitle3
  },
  props: ["target", "readonly", "task"],
  data() {
    return {
      editDetailsOpened: false,
      editPromptSelectionOpened: false,
      editProbingOpened: false,
      editActionRecommendationOpened: false
    };
  },

  computed: {
    ...mapGetters(["client"]),
    actionRecommendation() {
      return this.target.action_recommendations &&
        this.target.action_recommendations.at(0)
        ? this.target.action_recommendations.at(0)
        : {
          id: null,
          target_id: this.target.id,
          total_success: null,
          consecutive_success: null
        };
    }
  },
  methods: {
    displayDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      const day = `0${d.getDate()}`.slice(-2);
      const month = `0${d.getMonth() + 1}`.slice(-2);
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    onOpenEditDetails() {
      this.editDetailsOpened = true;
    },
    onOpenEditPromptSelection() {
      this.editPromptSelectionOpened = true;
    },
    onOpenEditProbing() {
      this.editProbingOpened = true;
    },
    onOpenEditActionRecommendation() {
      this.editActionRecommendationOpened = true;
    }
  }
};
</script>

<style scoped lang="scss">
.bl-target-details-container {
  position: relative;
  width: 100%;
  // height: calc(100% - 3.5625rem);
  box-sizing: border-box;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/clients/target/TaskPropertyDetails.vue